// extracted by mini-css-extract-plugin
export var buttonProvider = "styles-module--buttonProvider--2i2zD";
export var googleIcon = "styles-module--googleIcon--XPWD5";
export var facebookIcon = "styles-module--facebookIcon--3Ri2Y";
export var text = "styles-module--text--1LBpw";
export var buttonProviderAT = "styles-module--buttonProviderAT--2Hq_v";